

































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component
export default class JS010 extends Vue {
    @Prop({ type: [Number, String] })
    year!: number;

    form:any = {
        accountBookId: this.$store.state.accountBook.id,
        year: this.year,
        pensionNum: "",
        medicalNum: "",
        maternityInsuranceNum: "",
        unemploymentNum: "",
        injuryInsuranceNum: "",
        pensionBase: "",
        unemploymentBase: "",
        medicalBase: "",
        maternityInsuranceBase: "",
        isBase: "",
        pensionPaid: "",
        unemploymentPaid: "",
        medicalPaid: "",
        injuryInsurancePaid: "",
        maternityInsurancePaid: "",
        isPaid: "",
        pensionArrears: "",
        unemploymentArrears: "",
        medicalArrears: "",
        injuryInsuranceArrears: "",
        maternityInsuranceArrears: "",
        isArrears: "",
    }
    mounted() {
        this.fetchData();
    }
    async save() {
        const keys = Object.keys(this.form);
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            if(this.$store.state.accountBook.accountBookInfo.province ===  "辽宁省") {
                // @ts-ignore
                if (key != "gmtCreate" && key != "gmtModified" && key != "id" && key != "pensionNum"&& key != "unemploymentNum"&& key != "medicalNum"&& key != "injuryInsuranceNum"&& key != "maternityInsuranceNum") {
                    // @ts-ignore
                    if (this.form[key] === null || this.form[key] === "") {
                        this.$notify({
                            title: "温馨提示",
                            message: "请将所有信息填写完整",
                            type: "warning"
                        });
                        return;
                    }
                }
            } else {
                    // @ts-ignore
                if (key != "gmtCreate" && key != "gmtModified" && key != "id" && key != "injuryInsuranceBase"&& key != "pensionPayNum"&& key != "unemploymentPayNum"&& key != "medicalPayNum"&& key != "injuryInsurancePayNum"&& key != "maternityInsurancePayNum"&& key != "pensionPersonNum"&& key != "unemploymentPersonNum"&& key != "medicalPersonNum"&& key != "injuryInsurancePersonNum"&& key != "maternityInsurancePersonNum") {
                    // @ts-ignore
                    if (this.form[key] === null || this.form[key] === "") {
                        console.log(key)
                        this.$notify({
                            title: "温馨提示",
                            message: "请将所有信息填写完整",
                            type: "warning"
                        });
                        return;
                    }
                }
            }

        }
        await Vue.axios.post(`gsnb/sbxx/save`, this.form);
        this.fetchData()
        this.$emit("update", this.form);
    }
    async fetchData() {
        const res = await Vue.axios.get(`gsnb/sbxx/get?accountBookId=${this.$store.state.accountBook.id}&year=${this.year}`);
        if (res.data.data) {
            this.form = res.data.data
        }
    }

}
